<div class="white-bg" [ngClass]="{ 'full-height': fromMemo }">
  <app-back-header [title]="'ไม่สามารถลงนามเอกสารได้ ' | translate"
      (goBackEmit)="goBack()"></app-back-header>
  <div class="details-center">
    <div class="location-container">
      <div class="location-icon-container mb-l4">
        <div class="location-icon">
          <img src="assets/images/location.svg"
              alt="Location" />
        </div>
      </div>

      <!-- Location Info Text -->
      <div class="location-info text-center my-5">
        <h4 class="mb-4"><span class="icon-cus-size">📍</span>
          {{ 'กรุณาเปิดการเข้าถึงตำแหน่งของคุณ' | translate }}
        </h4>
        <p>{{ 'เพื่อให้สามารถลงนามได้อย่างสมบูรณ์' | translate }}</p>
        <p>{{ 'กรุณาอนุญาตให้ระบบเข้าถึงตำแหน่งของอุปกรณ์ของคุณ' | translate }}</p>
      </div>

      <!-- Android Instructions -->
      <div class="device-instructions mb-l4">
        <h5>{{ 'สำหรับอุปกรณ์ Android' | translate }}</h5>
        <ol>
          <li>{{ 'ไปที่ การตั้งค่า (Settings) > แอป (Apps) > [ชื่อเว็บแอปของคุณ]' | translate }}</li>
          <li>{{ 'เลือก สิทธิ์ (Permissions) > ตำแหน่ง (Location)' | translate }}</li>
          <li>{{ 'เลือก อนุญาตเฉพาะขณะใช้งานแอป (Allow only while using the app)' | translate }}</li>
        </ol>
      </div>

      <!-- iOS Instructions -->
      <div class="device-instructions mb-l4">
        <h5>{{ 'สำหรับอุปกรณ์ iOS (Safari)' | translate }}:</h5>
        <ol>
          <li>{{ 'เปิด แอป Settings > Safari > Location' | translate }}</li>
          <li>{{ 'เลือก While Using the Website หรือ Ask' | translate }}</li>
        </ol>
      </div>

      <!-- Warning -->
      <div class="warning-message text-center">
        <p><span class="icon-cus-size">⚠️</span> {{ 'หากยังไม่ได้อนุญาต' | translate }}</p>
        <p>{{ 'จะทำให้ไม่สามารถใช้งานฟีเจอร์ที่ต้องใช้ตำแหน่งได้' | translate }}</p>
      </div>
    </div>
  </div>
</div>